import { handleActions } from 'redux-actions'
import * as type from './type'


export const initialState = {
    barcode: {
        value: '',
    },
}


export default handleActions({
    [type.CHANGE_BAR_CODE]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            barcode: {
                [name]: value,
            },
        }
    },


}, initialState)



// WEBPACK FOOTER //
// ./src/modules/process/state/barcode/reducer.js